export const SUBAPPLICATION_TYPE_MAP = {
  PLAN: {
    code: '231',
    label: 'Plan',
  },
  PROJECT: {
    code: '232',
    label: 'Project',
  },
  MANAGEMENT_COST: {
    code: '233',
    label: 'Management Cost',
  },
  TECHNICAL_ASSISTANCE: {
    code: '234',
    label: 'Panel Review',
  },
  INITIATIVE_PROJECT: {
    code: '235',
    label: 'Initiative Project',
  },
  ADVANCED_ASSISTANCE: {
    code: '236',
    label: 'Advanced Assistance',
  },
};
